export class Pos {
  constructor(
    private _tid: string = null,
    private _serialNumber: string = null,
    private _merchantCode: string = null,
    private _terminalCode: string = null
  ) { }

  get tid(): string {
    return this._tid;
  }

  get serialNumber(): string {
    return this._serialNumber;
  }

  get merchantCode(): string {
    return this._merchantCode;
  }

  get terminalCode(): string {
    return this._terminalCode;
  }

  static fromRawPos(rawPos) {
    if(!rawPos) {
      return undefined;
    }
    return new Pos(
      rawPos.tid,
      rawPos.serial_number,
      rawPos.merchant_code,
      rawPos.terminal_code
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/model/pos.ts